import { SVGProps } from "react";

export const PinActive: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="62"
      height="72"
      viewBox="0 0 62 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_2083_8346)">
        <path
          d="M51 29.3333C51 45.6666 30 59.6666 30 59.6666C30 59.6666 9 45.6666 9 29.3333C9 23.7638 11.2125 18.4223 15.1508 14.4841C19.089 10.5458 24.4305 8.33331 30 8.33331C35.5695 8.33331 40.911 10.5458 44.8492 14.4841C48.7875 18.4223 51 23.7638 51 29.3333Z"
          fill="#E56E2E"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.128 28.2062C22.9354 27.876 22.7709 27.5271 22.63 27.169C18.6501 29.6202 16 33.9923 16 38.9737C16 43.9551 16 39.0481 16 39.0853H17.1512C17.1512 39.0481 17.1512 39.0109 17.1512 38.9737C17.1512 34.4481 19.5335 30.4713 23.128 28.2062Z"
          fill="white"
        />
        <path
          d="M24.6936 30.1411C24.3788 29.8621 24.0922 29.5551 23.8244 29.2249C20.5587 31.2667 18.3926 34.8667 18.3926 38.9737C18.3926 43.0807 18.3926 39.0481 18.3926 39.0853H19.6331C19.6331 39.0481 19.6331 39.0109 19.6331 38.9737C19.6331 35.2202 21.6629 31.9365 24.6936 30.1411Z"
          fill="white"
        />
        <path
          d="M27.0702 31.6109C26.5957 31.4249 26.1493 31.1923 25.7264 30.9225C22.8131 32.4528 20.835 35.4807 20.835 38.9737C20.835 42.4667 20.835 39.0481 20.835 39.0853H22.0331C22.0331 39.0481 22.0331 39.0109 22.0331 38.9737C22.0331 35.6342 24.1194 32.7784 27.0749 31.6109H27.0702Z"
          fill="white"
        />
        <path
          d="M36.9473 28.2062C37.1352 27.876 37.2997 27.5271 37.4406 27.169C41.3782 29.6202 44.0001 33.9923 44.0001 38.9737C44.0001 43.9551 44.0001 39.0481 44.0001 39.0853H42.8583C42.8583 39.0481 42.8583 39.0109 42.8583 38.9737C42.8583 34.4481 40.4995 30.4713 36.9473 28.2062Z"
          fill="white"
        />
        <path
          d="M35.3955 30.1411C35.7056 29.8621 35.9923 29.5551 36.2554 29.2249C39.4834 31.2667 41.6308 34.8667 41.6308 38.9737C41.6308 43.0807 41.6308 39.0481 41.6308 39.0853H40.4044C40.4044 39.0481 40.4044 39.0109 40.4044 38.9737C40.4044 35.2202 38.398 31.9365 35.4002 30.1411H35.3955Z"
          fill="white"
        />
        <path
          d="M33.0469 31.6109C33.5168 31.4249 33.9584 31.1923 34.3766 30.9225C37.257 32.4528 39.2164 35.4807 39.2164 38.9737C39.2164 42.4667 39.2164 39.0481 39.2164 39.0853H38.0323C38.0323 39.0481 38.0323 39.0109 38.0323 38.9737C38.0323 35.6342 35.9695 32.7784 33.0469 31.6109Z"
          fill="white"
        />
        <path
          d="M30.0301 17.6667C26.2946 17.6667 23.2686 20.662 23.2686 24.3597C23.2686 24.983 23.4048 25.8946 23.6539 26.5969C23.7854 26.9597 23.9452 27.3085 24.1331 27.6388C24.3399 28.0016 24.5795 28.3411 24.8473 28.6574C25.1293 28.9923 25.4488 29.2992 25.7918 29.5737C26.1724 29.8806 26.5906 30.1411 27.037 30.3597C27.9391 30.8016 28.9588 31.0527 30.0348 31.0527C31.1108 31.0527 32.1257 30.8016 33.0326 30.3597C33.479 30.1411 33.8925 29.876 34.2778 29.5737C34.6208 29.2992 34.9403 28.9923 35.2222 28.6574C35.4901 28.3411 35.7297 28.0016 35.9365 27.6388C36.1244 27.3085 36.2842 26.9597 36.4157 26.5969C36.6648 25.8992 36.801 25.1458 36.801 24.3597C36.801 20.662 33.775 17.6667 30.0395 17.6667H30.0301ZM34.7946 27.1225C34.5738 27.4946 34.3107 27.8341 34.0147 28.1411C33.6669 28.4946 33.2769 28.8062 32.8447 29.0574C32.0224 29.5411 31.0591 29.8155 30.0348 29.8155C29.0105 29.8155 28.0472 29.5365 27.2249 29.0574C26.7926 28.8062 26.4026 28.4946 26.0549 28.1411C25.7542 27.8341 25.4911 27.4899 25.2749 27.1225C25.0823 26.7969 24.9225 26.4481 24.7957 26.0806C24.6124 25.5365 24.5137 24.9597 24.5137 24.3551C24.5137 21.3365 26.9853 18.8899 30.0348 18.8899C33.0843 18.8899 35.5559 21.3365 35.5559 24.3551C35.5559 24.9132 35.4572 25.5365 35.2739 26.0806C35.1518 26.4481 34.992 26.7923 34.7946 27.1225Z"
          fill="white"
        />
        <path
          d="M30.0301 32.2806C26.2946 32.2806 23.2686 35.276 23.2686 38.9737C23.2686 39.8667 23.4048 40.5085 23.6539 41.2109C23.7854 41.5737 23.9452 41.9225 24.1331 42.2527C24.3399 42.6155 24.5795 42.9551 24.8473 43.2713C25.1293 43.6062 25.4488 43.9132 25.7918 44.1876C26.1724 44.4946 26.5906 44.7551 27.037 44.9737C27.9391 45.4155 28.9588 45.6667 30.0348 45.6667C31.1108 45.6667 32.1257 45.4155 33.0326 44.9737C33.479 44.7551 33.8925 44.4899 34.2778 44.1876C34.6208 43.9132 34.9403 43.6062 35.2222 43.2713C35.4901 42.9551 35.7297 42.6155 35.9365 42.2527C36.1244 41.9225 36.2842 41.5737 36.4157 41.2109C36.6648 40.5132 36.801 39.7597 36.801 38.9737C36.801 35.276 33.775 32.2806 30.0395 32.2806H30.0301ZM34.7946 41.7411C34.5738 42.1132 34.3107 42.4527 34.0147 42.7597C33.6669 43.1132 33.2769 43.4248 32.8447 43.676C32.0224 44.1597 31.0591 44.4341 30.0348 44.4341C29.0105 44.4341 28.0472 44.1551 27.2249 43.676C26.7926 43.4248 26.4026 43.1132 26.0549 42.7597C25.7542 42.4527 25.4911 42.1085 25.2749 41.7411C25.0823 41.4155 24.9225 41.0667 24.7957 40.6992C24.6124 40.1551 24.5137 39.5783 24.5137 38.9737C24.5137 35.9551 26.9853 33.5085 30.0348 33.5085C33.0843 33.5085 35.5559 35.9551 35.5559 38.9737C35.5559 39.6574 35.4572 40.1551 35.2739 40.6992C35.1518 41.0667 34.992 41.4109 34.7946 41.7411Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2083_8346"
          x="-6.16667"
          y="-1"
          width="74.6667"
          height="74.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.33333"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_2083_8346"
          />
          <feOffset
            dx="1.16667"
            dy="2.33333"
          />
          <feGaussianBlur stdDeviation="3.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.109804 0 0 0 0 0.105882 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2083_8346"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2083_8346"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const PinHover: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="62"
      height="72"
      viewBox="0 0 62 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_2083_8351)">
        <path
          d="M51 29.3333C51 45.6666 30 59.6666 30 59.6666C30 59.6666 9 45.6666 9 29.3333C9 23.7638 11.2125 18.4223 15.1508 14.4841C19.089 10.5458 24.4305 8.33331 30 8.33331C35.5695 8.33331 40.911 10.5458 44.8492 14.4841C48.7875 18.4223 51 23.7638 51 29.3333Z"
          fill="#FFEEE5"
          stroke="#C74601"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.128 28.2062C22.9354 27.876 22.7709 27.5271 22.63 27.169C18.6501 29.6202 16 33.9923 16 38.9737C16 43.9551 16 39.0481 16 39.0853H17.1512C17.1512 39.0481 17.1512 39.0109 17.1512 38.9737C17.1512 34.4481 19.5335 30.4713 23.128 28.2062Z"
          fill="#C74601"
        />
        <path
          d="M24.6936 30.1411C24.3788 29.8621 24.0922 29.5551 23.8244 29.2249C20.5587 31.2667 18.3926 34.8667 18.3926 38.9737C18.3926 43.0807 18.3926 39.0481 18.3926 39.0853H19.6331C19.6331 39.0481 19.6331 39.0109 19.6331 38.9737C19.6331 35.2202 21.6629 31.9365 24.6936 30.1411Z"
          fill="#C74601"
        />
        <path
          d="M27.0702 31.6109C26.5957 31.4249 26.1493 31.1923 25.7264 30.9225C22.8131 32.4528 20.835 35.4807 20.835 38.9737C20.835 42.4667 20.835 39.0481 20.835 39.0853H22.0331C22.0331 39.0481 22.0331 39.0109 22.0331 38.9737C22.0331 35.6342 24.1194 32.7784 27.0749 31.6109H27.0702Z"
          fill="#C74601"
        />
        <path
          d="M36.9473 28.2062C37.1352 27.876 37.2997 27.5271 37.4406 27.169C41.3782 29.6202 44.0001 33.9923 44.0001 38.9737C44.0001 43.9551 44.0001 39.0481 44.0001 39.0853H42.8583C42.8583 39.0481 42.8583 39.0109 42.8583 38.9737C42.8583 34.4481 40.4995 30.4713 36.9473 28.2062Z"
          fill="#C74601"
        />
        <path
          d="M35.3955 30.1411C35.7056 29.8621 35.9923 29.5551 36.2554 29.2249C39.4834 31.2667 41.6308 34.8667 41.6308 38.9737C41.6308 43.0807 41.6308 39.0481 41.6308 39.0853H40.4044C40.4044 39.0481 40.4044 39.0109 40.4044 38.9737C40.4044 35.2202 38.398 31.9365 35.4002 30.1411H35.3955Z"
          fill="#C74601"
        />
        <path
          d="M33.0469 31.6109C33.5168 31.4249 33.9584 31.1923 34.3766 30.9225C37.257 32.4528 39.2164 35.4807 39.2164 38.9737C39.2164 42.4667 39.2164 39.0481 39.2164 39.0853H38.0323C38.0323 39.0481 38.0323 39.0109 38.0323 38.9737C38.0323 35.6342 35.9695 32.7784 33.0469 31.6109Z"
          fill="#C74601"
        />
        <path
          d="M30.0301 17.6667C26.2946 17.6667 23.2686 20.662 23.2686 24.3597C23.2686 24.983 23.4048 25.8946 23.6539 26.5969C23.7854 26.9597 23.9452 27.3085 24.1331 27.6388C24.3399 28.0016 24.5795 28.3411 24.8473 28.6574C25.1293 28.9923 25.4488 29.2992 25.7918 29.5737C26.1724 29.8806 26.5906 30.1411 27.037 30.3597C27.9391 30.8016 28.9588 31.0527 30.0348 31.0527C31.1108 31.0527 32.1257 30.8016 33.0326 30.3597C33.479 30.1411 33.8925 29.876 34.2778 29.5737C34.6208 29.2992 34.9403 28.9923 35.2222 28.6574C35.4901 28.3411 35.7297 28.0016 35.9365 27.6388C36.1244 27.3085 36.2842 26.9597 36.4157 26.5969C36.6648 25.8992 36.801 25.1458 36.801 24.3597C36.801 20.662 33.775 17.6667 30.0395 17.6667H30.0301ZM34.7946 27.1225C34.5738 27.4946 34.3107 27.8341 34.0147 28.1411C33.6669 28.4946 33.2769 28.8062 32.8447 29.0574C32.0224 29.5411 31.0591 29.8155 30.0348 29.8155C29.0105 29.8155 28.0472 29.5365 27.2249 29.0574C26.7926 28.8062 26.4026 28.4946 26.0549 28.1411C25.7542 27.8341 25.4911 27.4899 25.2749 27.1225C25.0823 26.7969 24.9225 26.4481 24.7957 26.0806C24.6124 25.5365 24.5137 24.9597 24.5137 24.3551C24.5137 21.3365 26.9853 18.8899 30.0348 18.8899C33.0843 18.8899 35.5559 21.3365 35.5559 24.3551C35.5559 24.9132 35.4572 25.5365 35.2739 26.0806C35.1518 26.4481 34.992 26.7923 34.7946 27.1225Z"
          fill="#C74601"
        />
        <path
          d="M30.0301 32.2806C26.2946 32.2806 23.2686 35.276 23.2686 38.9737C23.2686 39.8667 23.4048 40.5085 23.6539 41.2109C23.7854 41.5737 23.9452 41.9225 24.1331 42.2527C24.3399 42.6155 24.5795 42.9551 24.8473 43.2713C25.1293 43.6062 25.4488 43.9132 25.7918 44.1876C26.1724 44.4946 26.5906 44.7551 27.037 44.9737C27.9391 45.4155 28.9588 45.6667 30.0348 45.6667C31.1108 45.6667 32.1257 45.4155 33.0326 44.9737C33.479 44.7551 33.8925 44.4899 34.2778 44.1876C34.6208 43.9132 34.9403 43.6062 35.2222 43.2713C35.4901 42.9551 35.7297 42.6155 35.9365 42.2527C36.1244 41.9225 36.2842 41.5737 36.4157 41.2109C36.6648 40.5132 36.801 39.7597 36.801 38.9737C36.801 35.276 33.775 32.2806 30.0395 32.2806H30.0301ZM34.7946 41.7411C34.5738 42.1132 34.3107 42.4527 34.0147 42.7597C33.6669 43.1132 33.2769 43.4248 32.8447 43.676C32.0224 44.1597 31.0591 44.4341 30.0348 44.4341C29.0105 44.4341 28.0472 44.1551 27.2249 43.676C26.7926 43.4248 26.4026 43.1132 26.0549 42.7597C25.7542 42.4527 25.4911 42.1085 25.2749 41.7411C25.0823 41.4155 24.9225 41.0667 24.7957 40.6992C24.6124 40.1551 24.5137 39.5783 24.5137 38.9737C24.5137 35.9551 26.9853 33.5085 30.0348 33.5085C33.0843 33.5085 35.5559 35.9551 35.5559 38.9737C35.5559 39.6574 35.4572 40.1551 35.2739 40.6992C35.1518 41.0667 34.992 41.4109 34.7946 41.7411Z"
          fill="#C74601"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2083_8351"
          x="-6.16667"
          y="-1"
          width="74.6667"
          height="74.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.33333"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_2083_8351"
          />
          <feOffset
            dx="1.16667"
            dy="2.33333"
          />
          <feGaussianBlur stdDeviation="3.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.109804 0 0 0 0 0.105882 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2083_8351"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2083_8351"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const PinDefault: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="62"
      height="72"
      viewBox="0 0 62 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_2083_8349)">
        <path
          d="M51 29.3333C51 45.6666 30 59.6666 30 59.6666C30 59.6666 9 45.6666 9 29.3333C9 23.7638 11.2125 18.4223 15.1508 14.4841C19.089 10.5458 24.4305 8.33331 30 8.33331C35.5695 8.33331 40.911 10.5458 44.8492 14.4841C48.7875 18.4223 51 23.7638 51 29.3333Z"
          fill="white"
          stroke="#E56E2E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.128 28.2062C22.9354 27.876 22.7709 27.5271 22.63 27.169C18.6501 29.6202 16 33.9923 16 38.9737C16 43.9551 16 39.0481 16 39.0853H17.1512C17.1512 39.0481 17.1512 39.0109 17.1512 38.9737C17.1512 34.4481 19.5335 30.4713 23.128 28.2062Z"
          fill="#E56E2E"
        />
        <path
          d="M24.6936 30.1411C24.3788 29.8621 24.0922 29.5551 23.8244 29.2249C20.5587 31.2667 18.3926 34.8667 18.3926 38.9737C18.3926 43.0807 18.3926 39.0481 18.3926 39.0853H19.6331C19.6331 39.0481 19.6331 39.0109 19.6331 38.9737C19.6331 35.2202 21.6629 31.9365 24.6936 30.1411Z"
          fill="#E56E2E"
        />
        <path
          d="M27.0702 31.6109C26.5957 31.4249 26.1493 31.1923 25.7264 30.9225C22.8131 32.4528 20.835 35.4807 20.835 38.9737C20.835 42.4667 20.835 39.0481 20.835 39.0853H22.0331C22.0331 39.0481 22.0331 39.0109 22.0331 38.9737C22.0331 35.6342 24.1194 32.7784 27.0749 31.6109H27.0702Z"
          fill="#E56E2E"
        />
        <path
          d="M36.9473 28.2062C37.1352 27.876 37.2997 27.5271 37.4406 27.169C41.3782 29.6202 44.0001 33.9923 44.0001 38.9737C44.0001 43.9551 44.0001 39.0481 44.0001 39.0853H42.8583C42.8583 39.0481 42.8583 39.0109 42.8583 38.9737C42.8583 34.4481 40.4995 30.4713 36.9473 28.2062Z"
          fill="#E56E2E"
        />
        <path
          d="M35.3955 30.1411C35.7056 29.8621 35.9923 29.5551 36.2554 29.2249C39.4834 31.2667 41.6308 34.8667 41.6308 38.9737C41.6308 43.0807 41.6308 39.0481 41.6308 39.0853H40.4044C40.4044 39.0481 40.4044 39.0109 40.4044 38.9737C40.4044 35.2202 38.398 31.9365 35.4002 30.1411H35.3955Z"
          fill="#E56E2E"
        />
        <path
          d="M33.0469 31.6109C33.5168 31.4249 33.9584 31.1923 34.3766 30.9225C37.257 32.4528 39.2164 35.4807 39.2164 38.9737C39.2164 42.4667 39.2164 39.0481 39.2164 39.0853H38.0323C38.0323 39.0481 38.0323 39.0109 38.0323 38.9737C38.0323 35.6342 35.9695 32.7784 33.0469 31.6109Z"
          fill="#E56E2E"
        />
        <path
          d="M30.0301 17.6667C26.2946 17.6667 23.2686 20.662 23.2686 24.3597C23.2686 24.983 23.4048 25.8946 23.6539 26.5969C23.7854 26.9597 23.9452 27.3085 24.1331 27.6388C24.3399 28.0016 24.5795 28.3411 24.8473 28.6574C25.1293 28.9923 25.4488 29.2992 25.7918 29.5737C26.1724 29.8806 26.5906 30.1411 27.037 30.3597C27.9391 30.8016 28.9588 31.0527 30.0348 31.0527C31.1108 31.0527 32.1257 30.8016 33.0326 30.3597C33.479 30.1411 33.8925 29.876 34.2778 29.5737C34.6208 29.2992 34.9403 28.9923 35.2222 28.6574C35.4901 28.3411 35.7297 28.0016 35.9365 27.6388C36.1244 27.3085 36.2842 26.9597 36.4157 26.5969C36.6648 25.8992 36.801 25.1458 36.801 24.3597C36.801 20.662 33.775 17.6667 30.0395 17.6667H30.0301ZM34.7946 27.1225C34.5738 27.4946 34.3107 27.8341 34.0147 28.1411C33.6669 28.4946 33.2769 28.8062 32.8447 29.0574C32.0224 29.5411 31.0591 29.8155 30.0348 29.8155C29.0105 29.8155 28.0472 29.5365 27.2249 29.0574C26.7926 28.8062 26.4026 28.4946 26.0549 28.1411C25.7542 27.8341 25.4911 27.4899 25.2749 27.1225C25.0823 26.7969 24.9225 26.4481 24.7957 26.0806C24.6124 25.5365 24.5137 24.9597 24.5137 24.3551C24.5137 21.3365 26.9853 18.8899 30.0348 18.8899C33.0843 18.8899 35.5559 21.3365 35.5559 24.3551C35.5559 24.9132 35.4572 25.5365 35.2739 26.0806C35.1518 26.4481 34.992 26.7923 34.7946 27.1225Z"
          fill="#E56E2E"
        />
        <path
          d="M30.0301 32.2806C26.2946 32.2806 23.2686 35.276 23.2686 38.9737C23.2686 39.8667 23.4048 40.5085 23.6539 41.2109C23.7854 41.5737 23.9452 41.9225 24.1331 42.2527C24.3399 42.6155 24.5795 42.9551 24.8473 43.2713C25.1293 43.6062 25.4488 43.9132 25.7918 44.1876C26.1724 44.4946 26.5906 44.7551 27.037 44.9737C27.9391 45.4155 28.9588 45.6667 30.0348 45.6667C31.1108 45.6667 32.1257 45.4155 33.0326 44.9737C33.479 44.7551 33.8925 44.4899 34.2778 44.1876C34.6208 43.9132 34.9403 43.6062 35.2222 43.2713C35.4901 42.9551 35.7297 42.6155 35.9365 42.2527C36.1244 41.9225 36.2842 41.5737 36.4157 41.2109C36.6648 40.5132 36.801 39.7597 36.801 38.9737C36.801 35.276 33.775 32.2806 30.0395 32.2806H30.0301ZM34.7946 41.7411C34.5738 42.1132 34.3107 42.4527 34.0147 42.7597C33.6669 43.1132 33.2769 43.4248 32.8447 43.676C32.0224 44.1597 31.0591 44.4341 30.0348 44.4341C29.0105 44.4341 28.0472 44.1551 27.2249 43.676C26.7926 43.4248 26.4026 43.1132 26.0549 42.7597C25.7542 42.4527 25.4911 42.1085 25.2749 41.7411C25.0823 41.4155 24.9225 41.0667 24.7957 40.6992C24.6124 40.1551 24.5137 39.5783 24.5137 38.9737C24.5137 35.9551 26.9853 33.5085 30.0348 33.5085C33.0843 33.5085 35.5559 35.9551 35.5559 38.9737C35.5559 39.6574 35.4572 40.1551 35.2739 40.6992C35.1518 41.0667 34.992 41.4109 34.7946 41.7411Z"
          fill="#E56E2E"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2083_8349"
          x="-6.16667"
          y="-1"
          width="74.6667"
          height="74.6667"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2.33333"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_2083_8349"
          />
          <feOffset
            dx="1.16667"
            dy="2.33333"
          />
          <feGaussianBlur stdDeviation="3.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.121569 0 0 0 0 0.109804 0 0 0 0 0.105882 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2083_8349"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2083_8349"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
